export const VISIBLE_FILTERS_LIMIT = 6;
